import { render, staticRenderFns } from "./ProductBuyVisite.vue?vue&type=template&id=27f5b839&scoped=true"
import script from "./ProductBuyVisite.vue?vue&type=script&lang=js"
export * from "./ProductBuyVisite.vue?vue&type=script&lang=js"
import style0 from "./ProductBuyVisite.vue?vue&type=style&index=0&id=27f5b839&prod&lang=scss&scoped=true"
import style1 from "./ProductBuyVisite.vue?vue&type=style&index=1&id=27f5b839&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f5b839",
  null
  
)

export default component.exports